import "./js/Proto.cjs";
import "babel-polyfill";

import Translation from "./js/Translation.js";
export let TR = Translation.lang;
export let g_euroDate = Translation.g_euroDate;
export let g_isEuro = Translation.g_isEuro;

import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";

import App from "./App.vue";
import TelemetryTranslation from "./assets/TelemetryTranslation";
import VModal from "vue-js-modal";
import VueApexCharts from "vue-apexcharts";
// import * as VueGoogleMaps from "vue2-google-maps";
import "leaflet/dist/leaflet.css";
//import VCalendar from "v-calendar";

import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import router from "./router.js";
import TButton from "./components/Controls/TButton.vue";
import TooltipButton from "./components/Controls/TooltipButton.vue";
import TDivider from "./components/Controls/TDivider.vue";
import TDateRangeInput from "./components/Controls/TDateRangeInput.vue";
import FilterButton from "./components/Controls/FilterButton.vue";
import Filters from "./components/Controls/Filters/Filters.vue";
import BackgroundView from "./components/LoginPage/BackgroundView.vue";
import SubComponent from "./components/Controls/SubscriptionPlan.vue";
import DeviceList from "./components/Controls/DeviceList.vue";
import HTTPSender from "./js/HTTPSender";
import DataManager, { ErrorMessage } from "./js/DataManager";
const TremolVIcon = require("./assets/img/Tremol V.png");
import global_dialog from "./g_dialog.js";

var global_dial = new global_dialog();
export let g_Dialog = global_dial;
var g_dialogLoader = {
  show: null,
  hide: null,
  hideSnackbar: null,
  showSnackbar: null,
  showError: null,
  showInfo: null,
};
var g_highlighter = {
  highlight: null,
  stop: null,
  visible: false,
  interval: null,
};
var g_currentRoute = {};
var g_userSettings = {
  denseGrid: true,
  darkMode: false,
  hideOldModels: false,
  showTooltips: true,
  showTimeOnDatePicker: false,
  showFlyingHelp: true,
  startPage: "",
};
var g_booleans = {
  bannerVisible: false,
  isLoading: true,
  editDeviceIndex: -1,
};

Vue.mixin({
  data() {
    return {
      Translation: Translation,
      TremolVIcon: TremolVIcon,
      highlighter: g_highlighter,
      dialogLoader: g_dialogLoader,
      dialog: global_dial,
      euroDate: Translation.g_euroDate,
      userSettings: g_userSettings,
      currentRoute: g_currentRoute,
      booleans: g_booleans,
      isResizeEnabled: false,
      wWidth: window.innerWidth,
      wLandscape: window.innerWidth > window.innerHeight,
      isOnFullScreen: false,
      global_rules: {
        required: [(v) => !!v || Translation.lang.Mandatory, (v) => (v && v.toString().length >= 2) || Translation.lang.NotValid],
        money: [(v) => (!!v && Number(v) == v && Number(v).roundTo(2) == v && v.toString().length < 9) || Translation.lang.NotRead],
        number9digits: [(v) => !!v || Translation.lang.Mandatory, (v) => (v && v.toString().length < 9) || Translation.lang.NotRead],
        number: [(v) => Number(v) == v || Translation.lang.NotValid],
        validEIK: [(v) => (v && ((v.length == 9 && this.isValidEIK(v)) || (v.length >= 10 && v.length <= 13))) || Translation.lang.NotValidEIK],
        username: [(v) => !!v || Translation.lang.PleaseEnterUsername, (v) => (v && v.length >= 3 && v.length < 30) || Translation.lang.Rules_Username],
        password: [(v) => !!v || Translation.lang.PasswordRequired, (v) => (v && v.length >= 3 && v.length < 30) || Translation.lang.PasswordMin6Max30Symbols],
        email: [(v) => !!v || Translation.lang.Mandatory, (v) => /.+@.+/.test(v) || Translation.lang.InvalidEmail],
      },
      xDown: null,
      yDown: null,
    };
  },
  computed: {
    editDeviceItemHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return TR.Locale == Translation.bg.Locale ? 450 : 320;
        case "md":
        case "lg":
        case "xl":
        default:
          return TR.Locale == Translation.bg.Locale ? 260 : 200;
      }
    },
    isBannerVisible() {
      return this.booleans.bannerVisible;
    },
    getBannerHeight() {
      return 0; // this.booleans.bannerVisible ? 48 : 0;
    },
    /** @return {Boolean}  */
    isInDarkMode() {
      return this.$vuetify.theme.dark;
    },
    /** @return {Boolean}  */
    isOnLandscape() {
      return this.wLandscape;
    },
    isOnAndroid() {
      var navvv = navigator.sayswho.toLowerCase();
      return navvv.indexOf("android") != -1; // || navvv.indexOf("safari") != -1;
    },
    /** @return {Boolean}  */
    isOnMobile() {
      //return this.$vuetify.breakpoint.mobile;
      switch (this.$vuetify.breakpoint.name) {
        case "md":
        case "lg":
        case "xl":
          return false;
        case "sm":
        case "xs":
        default:
          return true;
      }
    },
    /** @return {Boolean}  */
    isWithSmallWidth() {
      return this.wWidth <= 400;
    },
    hideTooltips() {
      return !this.userSettings.showTooltips || this.isOnAndroid;
    },
    mainContainerWidth() {
      return window.innerWidth - this.$vuetify.application.left - this.$vuetify.application.right;
    },
    menuWidth() {
      return this.$vuetify.application.left + this.$vuetify.application.right;
    },
    Colors() {
      return {
        IconColorHex: this.isInDarkMode ? "#1685c9" : "#1685c9",
        IconColor: this.isInDarkMode ? "rgb(22, 133, 201)" : "rgb(0, 46, 110)",
        InactiveIconColor: this.isInDarkMode ? "rgba(22, 133, 201, 0.3)" : "rgba(0, 46, 110, 0.3)",
        ActiveItemBackground: this.isInDarkMode ? "#4f4f4f" : "rgb(150, 196, 250)",
        MenuColor: this.isInDarkMode ? "" : "#d6ecfa", //rgb(213, 236, 244)",
        MenuTextColor: this.isInDarkMode ? "" : "rgb(0, 46, 110)",
        //  MenuColor: this.isInDarkMode ? "" : "rgb(92, 182, 243)",
        //  MenuTextColor: this.isInDarkMode ? "" : "rgb(245, 255, 255)",
        TransparentColor: "rgba(0, 0, 0, .05), rgba(0, 0, 0, .05)",
        SimpleBackground: this.isInDarkMode ? "#333" : "#FFF",
      };
    },
  },
  methods: {
    setLang(lang) {
      if (TR.Locale != lang) {
        TR = Object.assign({}, Translation[lang]);
        //TR = Translation[lang];
        Translation.setLang(lang);
        DataManager.__clean();
        localStorage.setItem("Country", lang);

        // this.$nextTick(() => {
        //   this.$router.push({ path: this.$router.currentRoute.path, query: { lang: lang } }).then(() => {
        //     this.$router.go(0);
        //   });
        // });
      }
    },
    isNumber(event, value) {
      if (!/^\d*(\.\d+)?$/g.test(event.key) || (value && value.toString().length > 9)) event.preventDefault();
    },
    isValidEIK(v) {
      var matches;
      if (!(matches = v.match(/^(BG)?((\d{9})(\d{4})?)$/))) return false;
      //1*а1+2*а2+3*а3+4*а4+5*а5+6*а6+7*а7+8*а8;
      var a = matches[3];
      var a9 = a[0] * 1 + a[1] * 2 + a[2] * 3 + a[3] * 4 + a[4] * 5 + a[5] * 6 + a[6] * 7 + a[7] * 8;
      a9 = a9 % 11;
      if (a9 == 10) {
        //3*а1+4*а2+5*а3+6*а4+7*а5+8*а6+9*а7+10*а8
        a9 = a[0] * 3 + a[1] * 4 + a[2] * 5 + a[3] * 6 + a[4] * 7 + a[5] * 8 + a[6] * 9 + a[7] * 10;
        a9 = a9 % 11;
      }
      a9 = a9 == 10 ? 0 : a9;
      if (a9 != a[8]) return false;
      if (!matches[4]) return true;
      //2*а9 + 7*а10 + 3*а11 +5*а12
      a = matches[4];
      var a13 = a9 * 2 + a[0] * 7 + a[1] * 3 + a[2] * 5;
      a13 = a13 % 11;
      //4*а9+9*а10+5*а11+7*а12
      if (a13 == 10) {
        a13 = a9 * 4 + a[0] * 9 + a[1] * 5 + a[2] * 7;
        a13 = a13 % 11;
      }
      a13 = a13 == 10 ? 0 : a13;
      return a13 == a[3];
    },
    toEuro(priceBGN) {
      if (g_isEuro) {
        return priceBGN * 1.95583;
      } else {
        return priceBGN / 1.95583;
      }
    },
    isValidEmail(email) {
      return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
    setBannerVisible(visible) {
      this.booleans.bannerVisible = visible;
    },
    /** @return {Boolean}  */
    isCapsLockOn(e) {
      // console.log(e);
      let caps = e.getModifierState && e.getModifierState("CapsLock");
      if (caps == true) return true;
      else return false;
    },
    openWebSite(site) {
      window.open(site, "_blank");
    },
    openTremolSite(deviceModel) {
      var ver = "bg";
      if (TR.Locale != "bg") {
        ver = "en";
      }
      if (deviceModel) {
        if (deviceModel.endsWith("KL") && !deviceModel.endsWith("V-KL")) {
          this.dialogLoader.showError("Стар модел устройство, който вече не се предлага");
        } else {
          this.openWebSite("https://tremol.bg/" + ver + "/product/" + deviceModel.replaceAll(" ", "-"));
        }
      } else {
        this.openWebSite("https://tremol.bg/" + ver + "/");
      }
    },
    openInvoice(invoice) {
      var newWindow = null;
      var invoiceData = "";
      HTTPSender.SendGETreq(DataManager.IIS_SERVER_URL, "/WebPms/Cosmos/Balance/GetInvoice", "blob", { inv: invoice })
        .done((data) => {
          // console.log("done")
          var blob = new Blob([data], {
            type: "application/pdf",
          });
          invoiceData = URL.createObjectURL(blob);

          if (this.isOnAndroid) {
            newWindow = window.open(invoiceData);
          } else {
            newWindow = window.open("/");
            // newWindow.onload = () => {
            newWindow.location.assign(invoiceData);
            // };
          }
          // // console.log(invoiceData)
          // // if (this.isOnMobile) {
          // // window.open(invoiceData);
          // newWindow.onload = () => {
          //   newWindow.location.
          //   newWindow.location.assign(invoiceData)
          // };
          newWindow.onclose = () => {
            try {
              URL.revokeObjectURL(invoiceData);
            } catch {
              /** ignored */
            }
          };
          // setTimeout(() => {
          //   if (newWindow.location == "https://10.10.10.189:8080/landing" || newWindow.location == "https://a.tremol.bg/landing" || newWindow.location == "https://a.tremol.bg/landing" || newWindow.location == "https://a.tremol.bg/login") {
          //     newWindow.close();
          //   }
          // }, 2222)
          // } else {
          //   this.dialog.show("invoice", invoiceData);
          // }
        })
        .fail((xhr, textStatus, errorThrown) => {
          this.dialogLoader.showError(Translation.lang.ErrorWhileLoadingInvoice + "!\n" + errorThrown, { location: "center" });
          try {
            URL.revokeObjectURL(invoiceData);
            newWindow.close();
          } catch {
            /** ignored */
          }
        });
      // window.open(DataManager.IIS_SERVER_URL + "/WebPms/Cosmos/Balance/GetInvoice?inv=" + invoice);
    },
    requestFullScreen() {
      var elem = document.documentElement;
      if (this.isOnFullScreen == false) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
      }
    },
    mainWindowResizeEvent() {
      this.wWidth = window.innerWidth;
      this.wLandscape = window.innerWidth > window.innerHeight;
    },
    fullScreenChanged() {
      if (document.fullScreen || document.msFullscreenElement || document.mozFullScreen || document.webkitIsFullScreen) {
        this.isOnFullScreen = true;
      } else {
        this.isOnFullScreen = false;
      }
    },
    logout(backToLogin) {
      this.booleans.isLoading = true;

      DataManager.__clean();
      this.$nextTick(() => {
        this.$router
          .push({ path: backToLogin ? "/login" : "/landing" })
          .catch(() => {})
          .then(() => {
            this.$vuetify.theme.dark = false;
            // if (!backToLogin) {
            document.title = "Tremol Assistant";
            this.booleans.isLoading = false;
            this.$router.go();
            // }
            // this.dialogLoader.showInfo("Успешен изход!");
          });
      });
      //TODO LOGOUT?
      // var request = new HTTPSender.SendGETreq(HTTPSender.IIS_SERVER_URL, "/logout");
      // request.done(function() {
      //   router.push({ path: "/login" });
      //   this.dialogLoader.showInfo("Успешен изход!");
      // });
      // request.fail(function(jqXHR, textStatus, errorThrown) {
      //   alert(jqXHR);
      //   console.log(jqXHR + textStatus + errorThrown);
      // });
    },
    getTrialDays(user) {
      var diffTime = Math.abs(user.dateAccountCreated.addDays(60) - new Date());
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
    async loadData(user, path, mustSub) {
      await g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: TR.LoadingDataPleaseWait });
      await DataManager.loadData(DataManager.DataType.monthly, undefined, true); //, new Date(2019, 0, 1), new Date());
      await g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: TR.LoadingReportsPleaseWait });
      await DataManager.loadData(DataManager.DataType.daily, undefined, true);
      // g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: "Зареждане на телеметрия, моля, изчакайте..." }); //TODO
      // this.$forceUpdate();
      // DataManager.loadData(DataManager.DataType.telemetry, () => {
      await g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: TR.LoadingSalesPleaseWait });
      await DataManager.loadData(DataManager.DataType.sales, undefined, true);
      await g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: TR.LoadingLastSalesPleaseWait });
      // if (TR.Locale == Translation.bg.Locale) {
      await DataManager.loadData(DataManager.DataType.sales_last_only, undefined, true);
      await DataManager.__fixData(DataManager.DataType.devices);
      await g_Dialog.close();

      if (path != null && this.$router.currentRoute.path != path) {
        if (this.$router.getRoutes().find((r) => r.path == path)) {
          this.$router.push({ path: path }).catch(() => {});
        }
      }
      if (TR.Locale == Translation.bg.Locale) {
        setTimeout(() => {
          if (DataManager.___demoMode) {
            this.dialog.show(
              g_Dialog.dialog_types.yes_no,
              null,
              {
                title: TR.Attention + "!",
                buttonNoText: TR.OK,
                text: TR.LoggedWithDemoAcc,
              },
              () => {
                if (user.observerCuser && this.user.approved) {
                  this.pickFirm(path);
                }
              },
            );
          } else if (mustSub) {
            var txt = "\t" + TR.NoDevsSubscribed + ".\n\t" + TR.PleaseSubscribeDevs;
            if (user.inTrial) {
              txt = "\t:" + TR.NoDevsSubscribed + ".\n\t" + TR.FreeOfChargePeriod + "\n\t" + TR.RedirectToSubscription;
            }
            g_Dialog.close().then(() => {
              g_Dialog.show(
                g_Dialog.dialog_types.yes_no,
                null,
                {
                  title: TR.Attention,
                  buttonNoText: TR.OK,
                  text: txt,
                },
                () => {
                  if (user.inTrial) {
                    var plans = DataManager.getData(DataManager.DataType.subscription_plans, true);
                    const maxPrice = Math.max(...plans.map((o) => o.price), 0);
                    const chosenPlan = plans.find((p) => p.price == maxPrice);
                    var devs = DataManager.getData(DataManager.DataType.devices, true).filter((d) => d.duprofile && d.duprofile.cosmosableDevice && d.sim && d.sim.activatedMo);
                    if (devs.length > 0) {
                      bus.$emit(bus.EVENT_Device_want_to_subscribe, devs, chosenPlan);
                    }
                  }
                },
              );
            });
          } else if (!user.approved) {
            g_Dialog.show(
              g_Dialog.dialog_types.yes_no,
              null,
              {
                title: "Внимание",
                buttonYesText: "Да",
                buttonNoText: "Не",
                text:
                  "\tАкаунтът Ви все още не е одобрен и нямате пълен достъп до системата.\nНеобходимо е да получим електронно подписана декларация или нотариално заверен оригинален хартиен носител.\nАко все още не сте попълнили и изпратили изисканата декларация, можете да я попълните в меню " +
                  (user.observerCuser ? "Декларация" : "Абонамент - Фирми на потребителя") +
                  ".\nЖелаете ли да бъдете препратени към менюто за генериране на декларация?",
              },
              (result) => {
                if (result == true) {
                  if (DataManager.userHasAccess(DataManager.UserTypes.Observer)) {
                    this.$router.push({ path: "/" + TR.Locale + "/obsDeclaration" }).catch(() => {});
                  } else if (DataManager.userHasAccess(DataManager.UserTypes.Owner)) {
                    this.$router.push({ path: "/" + TR.Locale + "/clients" }).catch(() => {});
                  }
                }
              },
            );
          } else if (user.inTrial && this.getTrialDays(user) <= 7 && user.balance == 0.01) {
            this.dialog.show(
              g_Dialog.dialog_types.yes_no,
              null,
              {
                title: TR.Attention,
                buttonNoText: TR.OK,
                text: TR.RemainingTrialDays + ": " + this.getTrialDays(user),
              },
              null,
            );
          } else if (user.observerCuser) {
            this.pickFirm(path);
          }
        }, 1000);
      }
    },
    async pickTechnician(user, path, mustSub) {
      var settings2 = DataManager.getData(DataManager.DataType.user).settings2;
      if (TR.Locale == Translation.ro.Locale && settings2.technicians && settings2.technicians.length > 0) {
        await g_Dialog.show(
          g_Dialog.dialog_types.picker,
          settings2.technicians,
          {
            title: TR.PleaseChooseTechnician,
            toStringFn: (t) => {
              return t.n;
            },
            tooltipFn: (t) => {
              return t.n + ", " + t.p;
            },
          },
          (tech) => {
            DataManager.currentTechnician = tech;
            this.loadData(user, path, mustSub);
          },
        );
      } else {
        this.loadData(user, path, mustSub);
      }
    },
    pickFirm(path) {
      DataManager.loadData(DataManager.DataType.clients, (errClients) => {
        if (errClients.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          this.clientFirms = DataManager.getData(DataManager.DataType.clients, true).map((item) => ({
            ...item,
            toString: function () {
              return item.orgName + " " + item.eik;
            },
          }));
          if (this.clientFirms.length > 0) {
            g_Dialog.show(
              g_Dialog.dialog_types.picker,
              this.clientFirms,
              {
                title: TR.PleaseChooseCustomer,
                buttonCancelText: "",
              },
              async (result) => {
                if (result != null) {
                  DataManager.currentUser = result;
                  await DataManager.reloadDeviceData().then(() => {
                    if (this.$router.currentRoute.path != path) {
                      if (this.$router.getRoutes().find((r) => r.path == path)) {
                        this.$router.push({ path: path }).catch(() => {});
                      }
                    }
                  });
                } else {
                  DataManager.currentUser = null;
                }
                Object.values(DataManager.DataType)
                  .filter((f) => f.access_type)
                  .forEach((d) => {
                    bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, d);
                  });
                //this.refreshData();
              },
            );
          } else {
            this.dialogLoader.hide();
            this.dialogLoader.showError(TR.NoCustomersToObserve, { location: "center" });
          }
        } else {
          this.dialogLoader.showError(errClients.Message, { location: "center" });
        }
      });
    },
    getTouches(evt) {
      return (
        evt.touches || // browser API
        evt.originalEvent.touches
      ); // jQuery
    },

    handleTouchStart(evt) {
      const firstTouch = this.getTouches(evt)[0];
      this.xDown = firstTouch.clientX;
      this.yDown = firstTouch.clientY;
    },

    // handleTouchMove(evt) {
    //   if (!this.xDown || !this.yDown) {
    //     return;
    //   }
    //   var xUp = evt.touches[0].clientX;
    //   var yUp = evt.touches[0].clientY;
    //   var xDiff = this.xDown - xUp;
    //   var yDiff = this.yDown - yUp;
    //   if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
    //     if (xDiff > 0) {
    //       bus.$emit(bus.EVENT_Android_Swipe, xUp < 10 ? bus.AndroidSwipes.endright : bus.AndroidSwipes.right)
    //     } else {
    //       bus.$emit(bus.EVENT_Android_Swipe, window.outerWidth - xUp < 10 ? bus.AndroidSwipes.endleft : bus.AndroidSwipes.left)
    //     }
    //   } else {
    //     if (yDiff > 0) {
    //       bus.$emit(bus.EVENT_Android_Swipe, bus.AndroidSwipes.down)
    //     } else {
    //       bus.$emit(bus.EVENT_Android_Swipe, bus.AndroidSwipes.up)
    //     }
    //   }
    //   /* reset values */
    //   this.xDown = null;
    //   this.yDown = null;
    // },
  },
  created() {
    document.addEventListener("fullscreenchange", this.fullScreenChanged);
    document.addEventListener("MSFullscreenChange", this.fullScreenChanged);
    document.addEventListener("touchstart", this.handleTouchStart, false);
    document.addEventListener("touchmove", this.handleTouchMove, false);
    window.addEventListener("resize", this.mainWindowResizeEvent);
    window.onbeforeunload = function () {
      if (!location.href.endsWith("landing") && !(DataManager.getData(DataManager.DataType.user, true) instanceof Array)) return "Your work will be lost.";
    };
    window.addEventListener("contextmenu", function (event) {
      event.preventDefault();
    });
    var cntr = localStorage.getItem("Country");
    if (cntr) {
      this.setLang(cntr);
    }
    //this.startAndroidCamera();
  },
  mounted() {
    this.mainWindowResizeEvent();
    // console.log("main.js")
    // console.log(JSON.stringify(this.dialog))
  },
  beforeDestroy() {
    document.removeEventListener("fullscreenchange", this.fullScreenChanged);
    document.removeEventListener("MSFullscreenChange", this.fullScreenChanged);
    document.removeEventListener("touchstart", this.handleTouchStart);
    document.removeEventListener("touchmove", this.handleTouchMove);
    window.removeEventListener("resize", this.mainWindowResizeEvent);
  },
});

Vue.config.productionTip = false; //TODO?

const tr = function (element) {
  let children = [...element.childNodes];
  children.forEach((child) => {
    tr(child);
    if (child.innerText) {
      if (TelemetryTranslation[child.innerText]) {
        child.innerText = TelemetryTranslation[child.innerText];
      }
      if (child.innerText.endsWith(":")) {
        var trimmed = child.innerText.substring(0, child.innerText.length - 1);
        if (TelemetryTranslation[trimmed]) {
          child.innerText = TelemetryTranslation[trimmed] + ":";
        }
      }
    }
  });
};
Vue.directive("translate", {
  bind: function (el) {
    tr(el);
  },
});

Vue.use(Vuetify);
//Vue.use(VCalendar, { componentPrefix: "vc" });
Vue.use(VModal, { dialog: true, dynamic: true });
Vue.use(VueApexCharts);

Vue.component("t-subplan", SubComponent);
Vue.component("t-background", BackgroundView);
Vue.component("t-date-range-input", TDateRangeInput);
Vue.component("t-divider", TDivider);
Vue.component("t-button", TButton);
Vue.component("TooltipButton", TooltipButton);
Vue.component("t-filter-button", FilterButton);
Vue.component("t-filters", Filters);
Vue.component("DeviceList", DeviceList);
Vue.component("apex-chart", VueApexCharts);
Vue.component("vue-draggable-resizable", VueDraggableResizable);

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyDPvAYjsAsaxJ0PQq7F7Ic-sudbJw3P9io",
//     libraries: "places",
//     region: "BG",
//     language: "bg",
//   },
// });

const bus = new Vue();
bus.models = {};
bus.EVENT_DataManager_DATA_CHANGED = "EVENT_DataManager_DATA_CHANGED";
bus.EVENT_DataManager_FILTERS_CHANGED = "EVENT_DataManager_FILTERS_CHANGED";
bus.EVENT_Device_started_to_edit = "EVENT_Device_started_to_edit";
bus.EVENT_Device_selected_for_subscribtion = "EVENT_Device_selected_for_subscribtion";
bus.EVENT_Device_want_to_subscribe = "EVENT_Device_want_to_subscribe";
bus.EVENT_Device_want_to_unsubscribe = "EVENT_Device_want_to_unsubscribe";
bus.EVENT_Device_subscribtion_changed = "EVENT_Device_subscribtion_changed";
bus.EVENT_AddTab_In_MainContent = "EVENT_AddTab_In_MainContent";
bus.EVENT_Help_Needed = "EVENT_Help_Needed";
bus.EVENT_Close_ChangePass = "EVENT_Close_ChangePass";
bus.EVENT_Close_InvoiceData = "EVENT_Close_InvoiceData";
bus.EVENT_DeviceDiv_ExpandInfoBySerialNumber = "EVENT_DeviceDiv_ExpandInfoBySerialNumber";
bus.EVENT_MailBox_ExpandMailById = "EVENT_MailBox_ExpandMailById";
bus.EVENT_Android_Swipe = "EVENT_Android_Swipe";
bus.AndroidSwipes = Object.freeze({
  left: "left",
  endleft: "endleft",
  right: "right",
  endright: "endright",
  up: "up",
  down: "down",
});

let colorPalette = [];
for (var i = 0; i < 5000; i++) {
  var randomColor = Math.floor(Math.random() * 16777215).toString(16);
  colorPalette.push("#" + randomColor.padStart(6, "0")); // За Apexchart-а трябва да са 6 символа задължително.
  //colorPalette.push("#" + randomColor);
}

export const ColorPalette = colorPalette;
export const g_UserSettings = g_userSettings;

export default bus;

//import colors from 'vuetify/lib/util/colors';
const vuetify = new Vuetify({
  // theme: {
  //   themes: {
  //     light: {
  //       base: colors.blue.accent1,
  //       anchor: colors.purple.accent2,
  //       primary: colors.purple.base,
  //       'primary--text': colors.blue.accent1,
  //       secondary: colors.lightBlue.darken1,
  //       accent: colors.blue.darken1,
  //       error: colors.red.lighten2,
  //       info: colors.grey.lighten4,
  //       success: colors.green.ancient2
  //     },
  //   },
  // },
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
